export default __webpack_public_path__ + "static/media/logo.748e830c.svg";